import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export function SiteHeader({ minimal = false }) {
  const { user } = useAuth();

  return (
    <header className="border-b border-border px-6 sm:px-10 py-4 flex items-center justify-between" data-testid="site-header">
      <div className="flex items-center gap-6">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-[#10B981] flex items-center justify-center">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="10" width="3" height="8" rx="1.5" fill="white" opacity="0.7" />
              <rect x="8" y="6" width="3" height="16" rx="1.5" fill="white" />
              <rect x="13" y="3" width="3" height="18" rx="1.5" fill="white" />
              <rect x="18" y="8" width="3" height="10" rx="1.5" fill="white" opacity="0.7" />
            </svg>
          </div>
          <span className="text-lg font-bold tracking-tight text-foreground">Whisper.AI</span>
        </Link>
        {!minimal && (
          <nav className="hidden md:flex items-center gap-5">
            <Link to="/pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</Link>
            <Link to="/guide" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Setup Guide</Link>
            <Link to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Blog</Link>
          </nav>
        )}
      </div>
      <div className="flex items-center gap-3">
        {user ? (
          <Link to="/dashboard" className="px-4 py-2 rounded-lg bg-[#10B981] text-white text-sm font-medium hover:bg-[#059669] transition-colors" data-testid="header-dashboard-btn">
            Dashboard
          </Link>
        ) : (
          <>
            <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="header-login">Sign In</Link>
            <Link to="/signup" className="px-4 py-2 rounded-lg bg-[#18181B] text-white text-sm font-medium hover:bg-[#27272A] transition-colors dark:bg-white dark:text-[#09090B]" data-testid="header-signup-btn">Get Started</Link>
          </>
        )}
      </div>
    </header>
  );
}
